import { render, staticRenderFns } from "./UserProfileMenu.vue?vue&type=template&id=1c709e6a&scoped=true&"
import script from "./UserProfileMenu.vue?vue&type=script&lang=js&"
export * from "./UserProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileMenu.vue?vue&type=style&index=0&id=1c709e6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c709e6a",
  null
  
)

export default component.exports